import * as React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import WalletIndexScreen from '../screens/wallet/Index';
import WalletPasscodeScreen from '../screens/wallet/Passcode';
import WalletAirtimeScreen from '../screens/wallet/Airtime';
import WalletAccountScreen from '../screens/wallet/Account';
import WalletSendStartScreen from '../screens/wallet/SendStart';
import WalletSendEndScreen from '../screens/wallet/SendEnd';

const Stack = createStackNavigator();
const INITIAL_ROUTE_NAME = 'WalletIndex';

function WalletStackNavigator({ navigation, route, setNavHeaderMode }) {

  return (
    <Stack.Navigator initialRouteName={INITIAL_ROUTE_NAME} headerMode="none">
      <Stack.Screen
        name="WalletIndex"
        component={WalletIndexScreen}
        />
      <Stack.Screen
        name="WalletPasscode"
        component={WalletPasscodeScreen}
        />
      <Stack.Screen
        name="WalletAirtime"
        component={WalletAirtimeScreen}
        />
      <Stack.Screen
        name="WalletAccount"
        component={WalletAccountScreen}
        />
      <Stack.Screen
        name="WalletSendStart"
        component={WalletSendStartScreen}
        />
      <Stack.Screen
        name="WalletSendEnd"
        component={WalletSendEndScreen}
        />
    </Stack.Navigator>
  );
}

export default WalletStackNavigator